import { Field } from "react-final-form";
import { useIntl } from "react-intl";
import Section from "../../../common/section";
import { DropdownInput, TextInput, FileInput } from "../../../common/fields";
import * as Validations from "../../../common/form/validator";
import countries from "../../../../assets/data/countries";

const EnterpriseDetailsForm = ({ onLogoSelect }) => {
  const intl = useIntl();
  return (
    <div className="grid gap-2">
      <Section title="enterprise_details" className="col-12">
        <div className="grid">
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="name"
              component={TextInput}
              type="text"
              label={intl.formatMessage({
                id: "name",
              })}
              placeholder={intl.formatMessage({
                id: "name",
              })}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="industry"
              component={TextInput}
              type="text"
              label={intl.formatMessage({
                id: "industry",
              })}
              placeholder={intl.formatMessage({
                id: "industry",
              })}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="address1"
              component={TextInput}
              type="text"
              label={intl.formatMessage({
                id: "address_1",
              })}
              placeholder={intl.formatMessage({
                id: "address_1",
              })}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="address2"
              component={TextInput}
              type="text"
              label={intl.formatMessage({
                id: "address_2",
              })}
              placeholder={intl.formatMessage({
                id: "address_2",
              })}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="country"
              component={DropdownInput}
              type="text"
              label={intl.formatMessage({
                id: "country",
              })}
              placeholder={intl.formatMessage({
                id: "country",
              })}
              filter
              options={countries.map((country) => ({
                value: country.country,
                name: country.country,
              }))}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="logo"
              component={FileInput}
              label={intl.formatMessage({
                id: "logo",
              })}
              placeholder={intl.formatMessage({
                id: "logo",
              })}
              accept=".jpg,.jpeg,.png"
              required
              size={1000 * 1024}
              onFileRead={onLogoSelect}
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
        </div>
      </Section>
      <Section title="contact_info" className="col-12">
        <div className="grid">
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="contactName"
              component={TextInput}
              type="text"
              label={intl.formatMessage({
                id: "contact_person",
              })}
              placeholder={intl.formatMessage({
                id: "contact_person",
              })}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="contactEmail"
              component={TextInput}
              type="email"
              icon="pi-envelope"
              placeholder={intl.formatMessage({
                id: "contact_email",
              })}
              label={intl.formatMessage({
                id: "contact_email",
              })}
              required
              validate={Validations.composeValidators(
                Validations.required,
                Validations.checkEmailFormat
              )}
            />
          </div>
        </div>
      </Section>
    </div>
  );
};

export default EnterpriseDetailsForm;
